import React, { Component } from "react";
//estilos de material design
import {
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  Avatar
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
//accedemos a el consumer del objeto firebase en este componente
import { consumerFirebase } from "../../../server";
//para poder extraer el valor del dispatch necesitamos importar el StateContext del archivo session/store.js
import { StateContext } from "../../../session/store";
//accedemos a la variable closeSession del archivo session/actions/sessionAction - para cambiar el comportamiento del boton de salir de sesion
import { exitSession } from "../../../session/actions/sessionAction";
//importamos el componente menu derecha
import { RightMenu } from "./rightMenu";
//importamos el componente menu derecha
import { LeftMenu } from "./leftMenu";
//importacion temporal para foto de usuario
import userPhotoTemp from "../../../logo.svg";
//para las rutas de la app - this.props.history.push("/auth/login")
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

const styles = theme => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex"
    }
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  grow: {
    flexGrow: 1
  },
  avatarSize: {
    width: 40,
    height: 40
  },
  listItemText: {
    fontZise: "14px",
    fontWeight: 600,
    paddingLeft: "15px",
    color: "#212121"
  },
  list: {
    width: 250
  }
});

class BarSession extends Component {
  //extraemos los valores del context provider incluidos en la variable SessionContext para poder  usar sus variables globales en el buttonRegister, y en particualr poder usar el dispatch
  static contextType = StateContext;

  //estado inicial
  state = {
    firebase: null,
    right: false,
    left: false
  };

  //metodo que nos permite salir de la sesion a traves de un onClick, situado en el archivo RightMenu
  closeSessionApp = async () => {
    //para salir de la sesion necesitamos el objeto firebase, la sesion y el dispatch
    const [{ sesion }, dispatch] = this.context;
    const { firebase } = this.state;
    // exitSession del archivo session/actions/sessionAction
    exitSession(dispatch, firebase).then(success => {
      alert("Saliste de sesión correctamente");
      this.props.history.push("/auth/login");
    });
  };

  //funcion que permite abrir y cerrar el menu derecho del componente Drawer a traves de un evento onClick
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  //cambia el objeto firebase si este es direrente al estado previo
  static getDerivedStateFromProps(nextProps, prevState) {
    let newObjects = {};
    if (nextProps.firebase !== prevState.firebase) {
      newObjects.firebase = nextProps.firebase;
    }
    return newObjects;
  }

  render() {
    const { classes } = this.props;
    //extraemos de nuevo el sesion y el dispatch del contexto global de la aplicacion
    //para extraer los valores del usuario actual
    const [{ sesion }, dispatch] = this.context;
    const { usuario } = sesion;

    //codigo para evitar conflictos con los tokens de firebase
    //añadido despues de crear el codigo de login con telefono
    const { firebase } = this.state;
    //si la sesion no exite remueve cualquier token de seguridad que exista dentro del browser, luego redirecciona la app a pagina de login
    if (!usuario) {
      exitSession(dispatch, firebase).then(success => {
        this.props.history.push("/auth/login");
      });
    }

    //texto de la barra de navegacion con nombre de usuario
    let textuser = usuario.name + " " + usuario.surname;
    //añadimos esto cuando el usuario hace login con el telefono
    if (!usuario.name) {
      textuser = usuario.phone;
    }

    //AÑADIDO PARA SALIR DE SESION
    /*const { firebase } = this.state;

        if(!usuario){
          closeSession(dispatch, firebase).then(success => {
            this.props.history.push("/auth/login");
          });
        }
        
        if(!usuario.name){
            textuser = usuario.phone;
        }*/
    //////////////////////

    return (
      <>
        {/* menu izquierdo */}
        <Drawer
          open={this.state.left}
          onClose={this.toggleDrawer("left", false)}
          anchor="left"
        >
          <div
            role="button"
            onClick={this.toggleDrawer("left", false)}
            onKeyDown={this.toggleDrawer("left", false)}
          >
            <LeftMenu classes={classes} />
          </div>
        </Drawer>

        {/* menu derecho */}
        <Drawer
          open={this.state.right}
          onClose={this.toggleDrawer("right", false)}
          anchor="right"
        >
          <div
            role="button"
            onClick={this.toggleDrawer("right", false)}
            onKeyDown={this.toggleDrawer("right", false)}
          >
            <RightMenu
              classes={classes}
              usuario={usuario}
              textuser={textuser}
              photouser={usuario.photo || userPhotoTemp}
              closeSession={this.closeSessionApp}
            />
          </div>
        </Drawer>

        <Toolbar>
          <IconButton color="inherit" onClick={this.toggleDrawer("left", true)}>
            <i className="material-icons">menu</i>
          </IconButton>

          <Typography variant="h6">JRG</Typography>

          <div className={classes.grow}></div>
          <div className={classes.sectionDesktop}>
            <IconButton color="inherit" component={Link} to="">
              <i className="material-icons">mail_outline</i>
            </IconButton>
            <Button color="inherit">{textuser}</Button>
            <Avatar src={usuario.photo || userPhotoTemp} />
            <Button color="inherit" onClick={this.closeSessionApp}>
              Exit
            </Button>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              color="inherit"
              onClick={this.toggleDrawer("right", true)}
            >
              <i className="material-icons">more_vert</i>
            </IconButton>
          </div>
        </Toolbar>
      </>
    );
  }
}

export default compose(
  withRouter,
  consumerFirebase,
  withStyles(styles)
)(BarSession);
